module.exports = __webpack_public_path__ + "images/bug_black_size_6_a85524775d3607c1be9c3352ef908d23.png";